<template>
  <div class="head">
    <div :class="`flex ${loading ? 'animate-blinking' : ''}`">
      <ListColumn
        v-for="(column, index) in columns"
        :key="`header-column-${index}`"
        :direction="column.direction"
        :label="column.label"
        :sortId="column.sortId"
        :loading="column.label === 'loading'"
        :onSort="onSort"
      />
    </div>
  </div>
</template>

<script>
import ListColumn from './Column.vue'

export default {
  name: 'ListHead',
  components: {
    ListColumn
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    onSort: {
      type: Function,
      default: () => () => null
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
